import React from "react";
import { Send } from "lucide-react";
import FormField from "./contact/FormField";
import ContactInfo from "./contact/ContactInfo";
import { useContactForm } from "../hooks/useContactForm";

function ContactForm() {
  const { form, sending, updateField, submit } = useContactForm();

  return (
    <form onSubmit={submit} className="bg-neutral-900/60 border border-neutral-800 p-8 space-y-5">
      <FormField label="NAME" required value={form.name} onChange={updateField("name")} />
      <FormField label="EMAIL" required type="email" value={form.email} onChange={updateField("email")} />
      <FormField label="PHONE" value={form.phone} onChange={updateField("phone")} />
      <FormField label="MESSAGE" required rows={5} value={form.message} onChange={updateField("message")} />
      <button
        type="submit"
        disabled={sending}
        className="btn-primary w-full bg-[#fbf3e4] text-neutral-900 py-3 font-medium tracking-wide flex items-center justify-center gap-2 hover:bg-white disabled:opacity-60"
      >
        {sending ? "Sending..." : (<>Send Enquiry <Send size={16} /></>)}
      </button>
      <p className="text-[11px] text-neutral-500 text-center">
        I typically reply within 24 hours. For faster response, message me on WhatsApp.
      </p>
    </form>
  );
}

export default function Contact() {
  return (
    <section id="contact" className="bg-neutral-950 text-[#fbf3e4] py-24 lg:py-32">
      <div className="max-w-6xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-2 gap-14">
        <ContactInfo />
        <ContactForm />
      </div>
    </section>
  );
}
